<div class="toast-stack" role="status" aria-live="polite">
  @for (t of toasts(); track t.id) {
    <div class="toast toast--{{ t.variant }}">
      <span class="toast__msg">{{ t.message }}</span>
      <button class="toast__close" type="button" (click)="dismiss(t.id)" aria-label="Cerrar">×</button>
    </div>
  }
</div>
